import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { ContactSection } from '@/components/landing/contact-section'

const Home: FC = (): ReactNode => {
    return (
        <Layout>
            <Seo />

            <ContactSection />
        </Layout>
    )
}

export default Home
